import React from "react";
import { Pie } from "react-chartjs-2";

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const BancoColors = {
  "Yape (BCP)": "#6a0dad",
  "Plin (Interbank)": "#00c853",
  "BBVA": "#004481",
  "Scotiabank": "#ed1c27",
  "Tunki (Scotiabank)": "#ff6b00",
};

export default function PieChart({ labels = [], data = [] }) {
  if (!labels.length || !data.length) {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p style={{ color: "#888", fontSize: "1.1rem" }}>Sin datos disponibles</p>
      </div>
    );
  }

  const backgroundColors = labels.map((l) => BancoColors[l] || "#999");

  const chartData = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: backgroundColors,
        borderColor: "#1a1a2e",
        borderWidth: 3,
        hoverBorderColor: "#ffffff",
        hoverBorderWidth: 4,
        hoverOffset: 15,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          color: "white",
          font: {
            size: 13,
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            weight: "500",
          },
          boxWidth: 18,
          boxHeight: 18,
          padding: 15,
          usePointStyle: true,
          pointStyle: "circle",
        },
      },
      tooltip: {
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        titleColor: "#ffffff",
        bodyColor: "#ffffff",
        borderColor: "rgba(255, 255, 255, 0.2)",
        borderWidth: 1,
        padding: 12,
        displayColors: true,
        callbacks: {
          label: (ctx) => {
            const label = ctx.label || "";
            const value = ctx.raw || 0;
            const total = ctx.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} depósitos (${percentage}%)`;
          },
        },
      },
    },
    cutout: "0%",
    animation: {
      animateRotate: true,
      animateScale: true,
      duration: 1000,
      easing: "easeOutQuart",
    },
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
      }}
    >
      <Pie data={chartData} options={options} />
    </div>
  );
}